export const AppRoutes = {
  CHECKOUT_COMMERCETOOLS: "/checkout/ct_checkout",
  CHECKOUT_PRECOMPOSER_STORYBLOK: "/checkout/sb_checkout",
  CART: "/cart",
};
